export default "__VITE_ASSET__hlY7x7O___"